import { tokenizer } from '../../services/utils'
import l10n from '../i18n/I18N'
import { removeLiveChatWidget } from './LiveChat'
import { removeZendeskWidget } from './ZendeskWidget'

const cxId = 'cx-messenger-script'

const addCXMessenger = (widget, openCallback, closeCallback, loginUser, openOnInit) => {
  console.log('[CXMessenger] add')
  if (isCXmessengerAdded()) {
    // cx messenger is already added
    return
  }

  const messengerTag = document.createElement('df-messenger')
  if (widget.attributes) {
    for (const key in widget.attributes) {
      messengerTag.setAttribute(key, widget.attributes[key])
    }
  }

  // not foolproof
  removeZendeskWidget()
  removeLiveChatWidget()

  const messengerChatBubbleTag = document.createElement('df-messenger-chat-bubble')
  messengerChatBubbleTag.setAttribute('chat-title', l10n.t['casino.chatTitle'])
  messengerChatBubbleTag.setAttribute('bot-writing-text', l10n.t['casino.chatbotWriting'])
  messengerTag.appendChild(messengerChatBubbleTag)

  const scriptTag = document.createElement('script')
  scriptTag.id = cxId
  scriptTag.src = widget.scriptSrc

  document.getElementsByTagName('body')[0].appendChild(scriptTag)
  scriptTag.after(messengerTag)

  messengerChatBubbleTag.addEventListener('df-chat-open-changed', event => {
    if (event.detail.isOpen) {
      if (openCallback) {
        openCallback()
      }
    } else {
      if (closeCallback) {
        closeCallback()
      }
    }
  })

  window.addEventListener('df-messenger-loaded', () => {
    console.log('[CXMessenger] loaded')
    // Messenger is now ready.

    if (widget.clearHistoryOnLoad) {
      clearCXMessenger()
    }

    if (widget.addUserIdToParamsOnReady) {
      setUserIdForCXMessenger(loginUser?.userId)
    }

    if (widget.useCustomStartMessage) {
      const welcomeMessage = loginUser?.username
        ? l10n.t['casino.chatbotLoggedInWelcomeMessage']
        : l10n.t['casino.chatbotLoggedOutWelcomeMessage']

      setCustomMessage(tokenizer(welcomeMessage, { '{username}': loginUser?.username }))
    }

    if (openOnInit) {
      openCXMessenger()
    }
  })
}

const removeCXMessenger = () => {
  console.log('[CXMessenger] remove')
  const dfMessenger = document.querySelector('df-messenger')
  if (dfMessenger) {
    dfMessenger.remove()
  }

  const messengerChatBubbleTag = document.querySelector('df-messenger-chat-bubble')
  if (messengerChatBubbleTag) {
    messengerChatBubbleTag.remove()
  }

  const scriptTag = document.getElementById(cxId)
  if (scriptTag) {
    scriptTag.remove()
  }
}

const isCXmessengerAdded = () => {
  return document.getElementById(cxId) !== null
}

const clearCXMessenger = () => {
  const dfMessenger = document.querySelector('df-messenger')
  if (dfMessenger && dfMessenger.startNewSession) {
    dfMessenger.startNewSession({ retainHistory: false })
  }
}

const openCXMessenger = () => {
  const dfMessengerBubble = document.querySelector('df-messenger-chat-bubble')
  if (dfMessengerBubble && dfMessengerBubble.openChat) {
    dfMessengerBubble.openChat()
  }
}

const closeCXMessenger = () => {
  const dfMessengerBubble = document.querySelector('df-messenger-chat-bubble')
  if (dfMessengerBubble && dfMessengerBubble.closeChat) {
    dfMessengerBubble.closeChat()
  }
}

const setQueryParameters = params => {
  const dfMessenger = document.querySelector('df-messenger')
  if (dfMessenger && dfMessenger.setQueryParameters && params) {
    dfMessenger.setQueryParameters(params)
  }
}

const setCustomMessage = message => {
  const dfMessenger = document.querySelector('df-messenger')
  if (dfMessenger) {
    dfMessenger.renderCustomText(message, true)
  }
}

const setUserIdForCXMessenger = userId => {
  setQueryParameters({
    parameters: {
      userId: userId ? userId : ''
    }
  })
}

export {
  addCXMessenger,
  removeCXMessenger,
  openCXMessenger,
  closeCXMessenger,
  isCXmessengerAdded,
  setUserIdForCXMessenger
}
